export default __webpack_public_path__ + "static/media/teste-acabou.475aa37d.svg";